module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 1
// module chunks = 1